// config.ts (или как у тебя называется этот файл)
/** Безопасное получение env из window */
const cfg = typeof window !== "undefined" && window.__ENV__ ? window.__ENV__ : {};
/** Утилита: убираем trailing slash */
function stripTrailingSlash(v) {
    return String(v || "").replace(/\/$/, "");
}
/** Утилита: проверка абсолютного URL */
function isAbsoluteUrl(v) {
    return /^https?:\/\//i.test(v);
}
/** 1) API base */
const apiBaseCandidate = String(cfg.API_BASE ?? cfg.REACT_APP_DJANGO_API_URL ?? "").trim();
const backendBaseCandidate = String(cfg.BACKEND_BASE ?? cfg.REACT_APP_BACKEND_BASE ?? "").trim();
const currentOrigin = typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : "";
const rawBase = apiBaseCandidate || backendBaseCandidate || currentOrigin;
/** 2) Backend base (если нужно отдельно) */
const rawBackendBase = backendBaseCandidate || rawBase;
/** 3) Tokens/IDs */
const rawMapboxToken = cfg.MAPBOX_TOKEN ?? cfg.REACT_APP_MAPBOX_TOKEN ?? "";
const rawVkClientId = cfg.VK_CLIENT_ID ?? cfg.REACT_APP_VK_APP_ID ?? "";
/** 4) CDN/assets base
 *  Логика:
 *  - если задан IMAGES_BASE — используем его для картинок
 *  - иначе если задан CDN_BASE — используем его
 *  - иначе пусто (тогда /images/... будет грузиться с текущего домена trackme.su)
 */
const rawCdnBase = cfg.CDN_BASE ?? "";
const rawImagesBase = cfg.IMAGES_BASE ?? rawCdnBase ?? "";
/** Экспорты */
export const BASE_URL = stripTrailingSlash(rawBase);
export const BACKEND_BASE = stripTrailingSlash(rawBackendBase);
export const MEDIA_BASE = stripTrailingSlash(cfg.MEDIA_BASE ?? "") || stripTrailingSlash(rawCdnBase) || BACKEND_BASE;
export const MAPBOX_TOKEN = String(rawMapboxToken);
export const VK_CLIENT_ID = String(rawVkClientId);
export const CDN_BASE = stripTrailingSlash(rawCdnBase);
export const IMAGES_BASE = stripTrailingSlash(rawImagesBase);
/** Общий конфиг API */
export const apiConfig = {
    baseUrl: BASE_URL,
    getToken: () => localStorage.getItem("accessToken"),
};
/**
 * Собирает URL для ассетов.
 * - Если передан абсолютный URL → возвращает как есть
 * - Если CDN_BASE пустой → возвращает путь как "/images/.."
 * - Если CDN_BASE задан → делает "https://static.../images/.."
 */
export function assetUrl(path, baseOverride) {
    if (!path)
        return "";
    // Уже абсолютная ссылка
    if (isAbsoluteUrl(path))
        return path;
    // Нормализуем путь к виду "/something"
    const normalized = path.startsWith("/") ? path : `/${path}`;
    // Если передали baseOverride — используем его
    const base = stripTrailingSlash(baseOverride ?? CDN_BASE);
    // Нет базы — оставляем относительный путь (будет на текущем домене)
    if (!base)
        return normalized;
    return `${base}${normalized}`;
}
/**
 * URL для картинок (public/images).
 * По умолчанию использует IMAGES_BASE (или CDN_BASE, если IMAGES_BASE не задан).
 */
export function imageUrl(path) {
    // Если кто-то передаёт "images/.." без ведущего слэша — тоже ок
    return assetUrl(path, IMAGES_BASE);
}
/**
 * Очень частый кейс: фон в стиле
 */
export function bgImageStyle(path) {
    return { backgroundImage: `url(${imageUrl(path)})` };
}
